import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeriesService } from 'app/lib/series.service';

@Component({
    selector: 'app-series-voices',
    templateUrl: './series-voices.component.html',
    styleUrls: ['./series-voices.component.scss'],
    standalone: false
})
export class SeriesVoicesComponent implements OnInit {
    enableStorySeries: boolean;
    enableBurningQuestionSeries: boolean;
    constructor(
        private router: Router,
        private location: Location,
        private seriesService: SeriesService
    ) {
        this.enableStorySeries =
            this.seriesService.checkSeriesTypesEnabled().enableStorySeries;
        this.enableBurningQuestionSeries =
            this.seriesService.checkSeriesTypesEnabled().enableBurningQuestionSeries;
    }

    ngOnInit(): void {}
    goToVoiceSeries(type: string) {
        switch (type) {
            case 'stories':
                this.router.navigate(['/app/series/voices/stories']);
                break;
            case 'burningQuestions':
                this.router.navigate(['/app/series/voices/burningQuestions']);
                break;
        }
    }
    goBack() {
        this.location.back();
    }
}
